import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import App from "./ui/pages/App";
import store, { persistor } from "./application/store/Store";
import "./ui/scss/app.scss";
import { PersistGate } from "redux-persist/integration/react";
import { MixpanelService } from "./infrastructure/services/tracker/mixpanel.service";
import { initializeAllAnalytics } from "infrastructure/services/client-analytics";
import { BrowserRouter } from "react-router-dom";

//TODO: Create a separated theme file and start to customize components via theme file instead of recreating and duplicating it.
import { SantanderTheme } from "ui/theme/SantanderTheme";

MixpanelService.initialize();
initializeAllAnalytics();

// Get basename from environment or default based on environment.
// Return undefined when app should run from root.
const getBasename = (): string | undefined => {
  const env = (import.meta as unknown as { env: Record<string, string | undefined> }).env;

  // If explicitly set, use it
  if (env.VITE_BASE_PATH) {
    const rawPath = env.VITE_BASE_PATH.trim();
    if (rawPath === "/") {
      return undefined;
    }
    const withLeadingSlash = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;
    return withLeadingSlash.endsWith("/")
      ? withLeadingSlash.slice(0, -1)
      : withLeadingSlash;
  }

  // Default: /vb for main-test (biometric), root for others
  const environment = env.VITE_ENVIRONMENT || "";
  return environment === "main-test" ? "/vb" : undefined;
};

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={SantanderTheme}>
        <BrowserRouter basename={getBasename()} useTransitions={false}>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);
